import axios from 'axios';
import { Dispatch } from 'redux';
import { ActionType } from '../Actions/ActionTypes';
import { properties, tags, types } from '../../../config/api';

function fetchTypes() {
    return axios.get(types)
}
function fetchProperties() {
    return axios.get(properties)
}
function fetchTags() {
    return axios.get(tags)
}

export const actionFetchHome = () => {

    return (dispatch: Dispatch) => {
        dispatch({ type: ActionType.HOME_LOAGING })
        Promise.all([fetchTypes(), fetchProperties(), fetchTags()]).then((res) => {
            dispatch({ type: ActionType.HOME_DATA, types: res[0].data.data, properties: res[1].data.data, tags: res[2].data.data })
        }).catch(err => {
            if (err.code === 'ERR_NETWORK') {
                dispatch({ type: ActionType.HOME_ERROR, message: 'ERR_NETWORK' })
            } else {
                dispatch({ type: ActionType.HOME_ERROR, message: err.response.data.error })
            }
        })
    }
}
